import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    pastTitle: true
  },
  mutations: {
    menu (state) {
      state.pastTitle = true
    },
    noMenu (state) {
      state.pastTitle = false
    }
  },
  getters: {
    titleCheck (state) {
      return state.pastTitle
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/globals.js